import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton, Tooltip } from "@mui/material";
import "./index.css";  // ← only for the CSS overrides above

const createToastWithCopy = (type, message, options) => {
  toast[type](
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",  // pin button to the top
      }}
    >
      <span
        style={{
          flex: 1,                  // take remaining width
          whiteSpace: "pre-wrap",   // wrap long text
          wordBreak: "break-word",
        }}
      >
        {message}
      </span>
      <button
        style={{
          backgroundColor: "transparent",
          cursor: "pointer",
          border: "none",
          padding: 0,
          marginLeft: 8,
        }}
        onClick={() => {
          navigator.clipboard.writeText(message);
          // toast.info("Copied!", { autoClose: 1000 });
        }}
      >
        <Tooltip title="Copy">
          <IconButton size="small">
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </button>
    </div>,
    options
  );
};

const CustomToast = {
  success: (
    message,
    options = { position: toast.POSITION.TOP_RIGHT, autoClose: 2500 }
  ) => {
    createToastWithCopy("success", message, options);
  },
  error: (
    message,
    options = { position: toast.POSITION.TOP_RIGHT, autoClose: 2500 }
  ) => {
    createToastWithCopy("error", message, options);
  },
  warning: (
    message,
    options = { position: toast.POSITION.TOP_RIGHT, autoClose: 2500 }
  ) => {
    createToastWithCopy("warn", message, options);
  },
  info: (
    message,
    options = { position: toast.POSITION.TOP_RIGHT, autoClose: 2500 }
  ) => {
    createToastWithCopy("info", message, options);
  },
  POSITION: {
    TOP_RIGHT: toast.POSITION.TOP_RIGHT,
    TOP_CENTER: toast.POSITION.TOP_CENTER,
    TOP_LEFT: toast.POSITION.TOP_LEFT,
  },
};

export default CustomToast;
